export default "__VITE_ASSET__B4T_avHj__"